import { generateBFFUrl, SERVICE_COST_API } from '@/configs/apiEndPoints';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';

export const getServiceCost = async (
  assetId: string,
  incidentTypeId?: string,
  serverCookie?: any,
): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(SERVICE_COST_API), {
      headers: generateHttpHeaders(serverCookie),
      params: {
        assetId,
        incidentTypeId,
      },
    });
    // return response?.data?.data?.amount;
    return response?.data?.data;
  } catch (err: any) {
    const { response } = err;
    if (response) {
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Failed to fetch service cost', status, statusText, data);
    }
    console.error('API call failed without response:', err);
    return 0;
  }
};
